import slick from 'slick-carousel';

export default function initCarousel() {
	const carousel = '[data-carousel]';
	if ($(carousel).length > 0) {
		$.each($(carousel), function () {
			let show = $(this).data('show');
			let showsm = $(this).data('showsm');
			let showxs = $(this).data('showxs');
			let slide = $(this).data('slide');
			let arrows = $(this).data('arrows');
			let arrowsxs = $(this).data('arrowsxs');
			let dots = $(this).data('dots');
			let dotsxs = $(this).data('dotsxs');
			let center = $(this).data('center');
			let centerxs = $(this).data('centerxs');
			let infinite = $(this).data('infinite');
			let speed = $(this).data('speed');
			let drag = $(this).data('drag');
			let autoplay = $(this).data('autoplay');
			let autoplaySpeed = $(this).attr('data-autoplaySpeed');

			$(this).slick({
				slidesToShow: (show !== '') ? show : 3,
				slidesToScroll: (slide !== '') ? slide : 1,
				arrows: (arrows === false) ? arrows : true,
				dots: (dots === true) ? dots : false,
				centerMode: (center === true) ? center : false,
				infinite: (infinite === false) ? infinite : true,
				speed: (speed !== '') ? speed : 300,
				prevArrow: '<button class="slick-prev"></button>',
				nextArrow: '<button class="slick-next"></button>',
				draggable: (drag !== '') ? drag : true,
				autoplay: (autoplay !== '') ? autoplay : true,
				fade: true,
				autoplaySpeed: (autoplaySpeed !== '') ? parseInt(autoplaySpeed) : 2000,
				responsive: [{
						breakpoint: 992,
						settings: {
							slidesToShow: (showsm !== '') ? showsm : 1,
							fade: true,
						}
					},
					{
						breakpoint: 768,
						settings: {
							slidesToShow: (showxs !== '') ? showxs : 1,
							dots: (dotsxs === true) ? dotsxs : false,
							arrows: (arrowsxs === true) ? arrowsxs : false,
							centerMode: (centerxs === true) ? centerxs : false,
							fade: true,
						}
					}
				]
			});
		});
	}

	function btnArrow(next, prev, carousel) {
		$(next).click(() => $(carousel).slick('slickNext'));
		$(prev).click(() => $(carousel).slick('slickPrev'));
	}

	btnArrow('#blog .slick-next', '#blog .slick-prev', '#blog [data-carousel]');
	btnArrow('.about__recognition .slick-next', '.about__recognition .slick-prev', '.about__recognition [data-carousel]');
	btnArrow('.about__premium .slick-next', '.about__premium .slick-prev', '.about__premium [data-carousel]');
	btnArrow('.depoimentos .slick-next', '.depoimentos .slick-prev', '.depoimentos [data-carousel]');
	btnArrow('#bag .slick-next', '#bag .slick-prev', '#bag [data-carousel]');
	btnArrow('#bagDownload .slick-next', '#bagDownload .slick-prev', '#bagDownload [data-carousel]');
	btnArrow('#productDetail .slick-next', '#productDetail .slick-prev', '#productDetail [data-carousel]');
}